(() => {
  const roots = document.querySelectorAll("[data-article-product-carousel]");
  const pc = window.matchMedia("(min-width: 1024px)");

  roots.forEach((root) => {
    const track = root.querySelector("[data-carousel-track]");
    const bar = root.querySelector("[data-carousel-scrollbar]");
    const thumb = root.querySelector("[data-carousel-thumb]");
    const prev = root.querySelector("[data-carousel-prev]");
    const next = root.querySelector("[data-carousel-next]");
    const nav = prev ? prev.parentElement : null;
    if (!track || !bar || !thumb) return;

    const step = () => {
      const card = track.querySelector(".article-product-carousel__card");
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    // PC はボタンとインジケータを常に出す。SP は横にはみ出すときだけ出す
    const update = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const overflowing = maxScroll > 1;
      const visible = overflowing || pc.matches;
      bar.hidden = !visible;
      if (nav) nav.hidden = !visible;
      if (!visible) return;
      if (prev) prev.disabled = !overflowing || track.scrollLeft <= 1;
      if (next) next.disabled = !overflowing || track.scrollLeft >= maxScroll - 1;
      const barWidth = thumb.parentElement.clientWidth;
      // PC のつまみは Figma（バー 892px につまみ 220px）と同じ比率で固定。SP は表示割合に比例
      const ratio = overflowing ? track.clientWidth / track.scrollWidth : 1;
      const thumbWidth = pc.matches ? barWidth * (220 / 892) : Math.max(barWidth * ratio, 24);
      const left = overflowing ? (barWidth - thumbWidth) * (track.scrollLeft / maxScroll) : 0;
      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${left}px)`;
    };

    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if (pc.addEventListener) pc.addEventListener("change", update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  });
})();
